import React from "react";
import { Users, Loader2, CheckCircle, AlertTriangle } from "lucide-react";

const NomesCadastradosCard = ({ nomesConfig, loadingNomes, onNavigateNomes }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-border flex flex-col h-full">
      <div className="flex items-center gap-3 p-5 border-b border-border bg-slate-50 rounded-t-xl">
        <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center shadow-sm">
          <Users className={`w-5 h-5 ${nomesConfig ? "text-emerald-500" : "text-amber-500"}`} />
        </div>
        <h2 className="text-base font-semibold text-foreground">Nomes cadastrados</h2>
      </div>

      <div className="p-5 flex-1">
        <p className="text-sm text-muted-foreground mb-4">
          Configuração dos nomes para monitoramento das distribuições.
        </p>
        <div className="bg-slate-50 rounded-lg p-3">
          {loadingNomes ? (
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Loader2 className="w-4 h-4 animate-spin" />
              <span>Verificando...</span>
            </div>
          ) : nomesConfig ? (
            <div className="flex items-center gap-2 text-sm text-emerald-600">
              <CheckCircle className="w-4 h-4" />
              <span>Nomes configurados</span>
            </div>
          ) : (
            <div className="flex items-center gap-2 text-sm text-amber-600">
              <AlertTriangle className="w-4 h-4" />
              <span>Nomes não configurados</span>
            </div>
          )}
        </div>
      </div>

      <div className="p-5 border-t border-border">
        {loadingNomes ? (
          <button className="w-full py-2 px-4 rounded-md bg-slate-200 text-slate-500 text-sm font-medium cursor-not-allowed" disabled>
            Carregando...
          </button>
        ) : (
          <button
            className={`w-full py-2 px-4 rounded-md text-white text-sm font-medium transition-colors ${
              nomesConfig
                ? "bg-emerald-500 hover:bg-emerald-600"
                : "bg-amber-500 hover:bg-amber-600"
            }`}
            onClick={onNavigateNomes}
          >
            {nomesConfig ? "Gerenciar nomes" : "Configurar nomes"}
          </button>
        )}
      </div>
    </div>
  );
};

export default NomesCadastradosCard;
